import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Row, Spin } from "antd";

import partnersApi from "../../../apis/Partners.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import { loginAlert } from "../../AlertComponent";
import CommunityEachComponent from "../community/communityEach/CommunityEachComponent";
import CommunityModal from "../community/CommunityModal";

const HomeCommunity = ({ ingreList }) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const obsRef = useRef(null); //observer Element
	const preventRef = useRef(true); //옵저버 중복 실행 방지
	const endRef = useRef(false); //모든 글 로드 확인
	const [page, setPage] = useState(4); //현재 페이지

	const [communityList, setCommunityList] = useState([]);
	const [selectCommunity, setSelectCommunity] = useState({});
	const [modalShow, setModalShow] = useState(false);
	const [totalCnt, setTotalCnt] = useState(0);

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	// useEffect(() => {
	//     getCommunityList();
	//     return () => {
	//         setCommunityList(communityList);
	//     }
	// }, [])

	useEffect(() => {
		const observer = new IntersectionObserver(obsHandler, { threshold: 0.5 });
		if (obsRef.current) observer.observe(obsRef.current);
		return () => {
			observer.disconnect();
		};
	});

	useEffect(() => {
		if (reduxChannel?.user_id) {
			getCommunityList();
		}
	}, [reduxChannel]);

	const obsHandler = (entries) => {
		//옵저버 콜백함수
		const target = entries[0];
		if (!endRef.current && target.isIntersecting && preventRef.current) {
			//옵저버 중복 실행 방지
			preventRef.current = false; //옵저버 중복 실행 방지
			if (totalCnt >= page) {
				setPage((prev) => prev + 4); //페이지 값 증가
			} else {
				endRef.current = true;
			}
		}
	};

	useEffect(() => {
		getCommunity();
	}, [page]);

	const getCommunity = useCallback(async () => {
		setIsLoading(true);
		let param = {
			influencerId: reduxChannel?.user_id,
			offset: 0,
			pageSize: page,
			pageType: "user",
		};
		const res = await partnersApi.readCommunityList(param);
		if (res.code === 200) {
			setCommunityList(res.result?.communityDTOList);
			preventRef.current = true;
			endRef.current = false;
		}
		setIsLoading(false);
	}, [page]);

	const getCommunityList = async () => {
		setIsLoading(true);
		let param = {
			influencerId: reduxChannel?.user_id,
			offset: 0,
			pageSize: page,
			pageType: "user",
		};
		const res = await partnersApi.readCommunityList(param);
		if (res.code === 200) {
			setTotalCnt(res.result.totalCnt);
			setCommunityList(res.result?.communityDTOList);
			preventRef.current = true;
			endRef.current = false;
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getCommunityListModal();
		if (!modalShow) {
			setScrollToComment(false);
		}
	}, [modalShow]);

	const getCommunityListModal = useCallback(async () => {
		let param = {
			influencerId: reduxChannel?.user_id,
			offset: 0,
			pageSize: page,
			pageType: "user",
		};
		const res = await partnersApi.readCommunityList(param);
		if (res.code === 200) {
			setTotalCnt(res.result.totalCnt);
			setCommunityList(res.result?.communityDTOList);
			preventRef.current = true;
			endRef.current = false;
		}
	}, [modalShow]);

	const setScrollSession = () => {
		sessionStorage.setItem("scroll", String(window.scrollY));
	};

	const handleCommunity = (item) => {
		clickCommunityView(item).then((res) => {
			if (res) {
				if (mediaResult) {
					history.push(
						`/together/channel/community/${item.id}?id=${reduxChannel?.influencer_id}`
					);
				} else {
					setModalShow(!modalShow);
					setSelectCommunity(item);
				}
			}
		});
		setScrollSession();
	};
	const [scrollToComment, setScrollToComment] = useState(false);

	/**
	 * 댓글쓰기 클릭 시 댓글로 스크롤
	 * @param e
	 */
	const handleCommentMove = (e, item) => {
		e.stopPropagation();
		if (mediaResult) {
			sessionStorage.setItem("comment-scroll", "scroll");
			history.push(
				`/together/channel/community/${item.id}?id=${reduxChannel?.influencer_id}`
			);
		} else {
			setScrollToComment(true);
			setModalShow(!modalShow);
			setSelectCommunity(item);
		}
	};

	/**
	 * 소통글 클릭 조회 추가
	 * @param item
	 * @returns {Promise<void>}
	 */
	const clickCommunityView = async (item) => {
		if (!cUser?.id) {
			if (reduxChannel?.login_community_menu) {
				loginAlert({ history, reduxChannel });
				return false;
			} else {
				const param = {
					id: item.id,
					updated_by: cUser?.id,
					influencer_id: reduxChannel?.user_id,
				};
				await partnersApi.createViewCommunity(param);
				return true;
			}
		} else {
			const param = {
				// target_type: "community",
				// target_id: item.id,
				// action: "read",
				// created_by: cUser?.id,
				id: item.id,
				updated_by: cUser?.id,
				influencer_id: reduxChannel?.user_id,
			};
			await partnersApi.createViewCommunity(param);
			return true;
		}
	};

	// const body = document.querySelector("body");
	// console.log(body.offsetTop, window.scrollY, body.scrollHeight, body.scrollTop);

	return (
		<div
			className={`home-body home-each home-link-connection home-community-list-body
            home-channel-triple-each-second`}
			style={{ backgroundColor: "#f8f9fa" }}
		>
			<div className={`home-images-group max-width-apply`}>
				<div className={`home-recommend-horizontal`}>
					{/*<div className={`recommend-title`}>*/}
					{/*    <p className={`type-kr`}>*/}
					{/*        소통*/}
					{/*    </p>*/}
					{/*    <p className={`title`}>*/}
					{/*        {reduxChannel?.nickname}의 이야기*/}
					{/*    </p>*/}
					{/*</div>*/}
					{communityList?.length ? (
						<div className={`home-community-group`}>
							<CommunityEachComponent
								communityList={communityList}
								handleCommunity={handleCommunity}
								handleCommentMove={handleCommentMove}
								ingreList={ingreList}
							/>
						</div>
					) : (
						<Row
							align={"middle"}
							style={{
								width: "100%",
								flexDirection: "column",
								padding: "3em 0",
							}}
						>
							<img
								src={`/assets/images/warning.png`}
								alt={`warning-icon`}
								style={{
									width: "3.5em",
									height: "auto",
								}}
							/>
							<span
								style={{
									marginTop: "1em",
									color: "#adb5bd",
									fontSize: "1.2em",
									fontWeight: 500,
								}}
							>
								작성된 글이 없습니다.
							</span>
						</Row>
					)}
					{/*{!!communityList?.length && (*/}
					{/*    <Link*/}
					{/*        to={`/together/channel/communities?id=${reduxChannel?.influencer_id}`}*/}
					{/*        className={`recommend-button`}*/}
					{/*    >*/}
					{/*        전체보기*/}
					{/*    </Link>*/}
					{/*)}*/}
				</div>

				{/* 건별 콘텐츠 보기 */}
				{modalShow && (
					<CommunityModal
						modalShow={modalShow}
						setModalShow={setModalShow}
						detail={selectCommunity}
						getCommunityList={getCommunityList}
						scrollToComment={scrollToComment}
					/>
				)}
			</div>
			{isLoading && (
				<Spin
					style={{
						position: "fixed",
						margin: "auto",
						width: "100%",
						left: 0,
						right: 0,
						bottom: "2em",
					}}
				/>
			)}
			{!isLoading && totalCnt < page && !!communityList?.length && (
				<button
					style={{
						width: "100%",
						color: "#868e96",
						padding: "2em",
						backgroundColor: "inherit",
					}}
					onClick={() => {
						window.scrollTo({
							top: 0,
							behavior: "smooth",
						});
					}}
				>
					마지막 게시글입니다. 맨 위로 올라가기
				</button>
			)}
			<div
				ref={obsRef}
				style={{
					height: 30,
				}}
			/>
		</div>
	);
};
export default HomeCommunity;
